// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-EditForm-styles---container---1NoTb","form":"_-src-components-EditForm-styles---form---2N60I","header":"_-src-components-EditForm-styles---header---6Fu9w","dropdown":"_-src-components-EditForm-styles---dropdown---yNzvZ","ruleNameContainer":"_-src-components-EditForm-styles---ruleNameContainer---3w9Ww"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditForm/styles.css
// module id = 824
// module chunks = 0